import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput ,
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';


const getValidate=(val) => {
    let dummy= null;
    if(!val || val.indexOf('/') < 1 ){
        dummy = (document.getElementById("tx_pressure"))? document.getElementById("tx_pressure").setAttribute("style", "color: red;"): null;
       
    }else {
        let valArr = val.split('/');
        if(valArr[0] === null || valArr[1] === null){
            dummy = (document.getElementById("tx_pressure"))? document.getElementById("tx_pressure").setAttribute("style", "color: red;"): null;
           
        }else if(parseInt(valArr[0],10) < 100 || parseInt(valArr[0],10) > 180 || parseInt(valArr[1],10) < 50 || parseInt(valArr[1],10) < 50 || parseInt(valArr[1],10) > 100 ){
            dummy = (document.getElementById("tx_pressure"))? document.getElementById("tx_pressure").setAttribute("style", "color: red;"): null;
            
        }else{
            dummy = (document.getElementById("tx_pressure"))?document.getElementById("tx_pressure").removeAttribute("style"):null;
        }

       
       
    }
    return val
}


const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();

    return (
        <Fragment>
             <TableCell >
                <TextInput 
                    id="tx_pressure"
                    source="blood_pressure" 
                    label=""
                    onChange ={getValidate(formData.blood_pressure),
                        formData.blood_pressure = getValidate(formData.blood_pressure) 
                    }
                    {...rest}
                    />
             </TableCell>          
        </Fragment>
    );
};
const Pressure = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default Pressure